import * as AvatarPrimitive from '@radix-ui/react-avatar'
import PropTypes from 'prop-types'

import { cn } from '@/utils/helpers'

function Avatar({ className, ...props }) {
  return (
    <AvatarPrimitive.Root
      data-slot="avatar"
      className={cn('relative flex size-8 shrink-0 overflow-hidden rounded-lg', className)}
      {...props}
    />
  )
}

Avatar.propTypes = {
  className: PropTypes.string,
}

function AvatarImage({ className, ...props }) {
  return (
    <AvatarPrimitive.Image
      data-slot="avatar-image"
      className={cn('aspect-square size-full', className)}
      {...props}
    />
  )
}

AvatarImage.propTypes = {
  className: PropTypes.string,
}

function AvatarFallback({ className, ...props }) {
  return (
    <AvatarPrimitive.Fallback
      data-slot="avatar-fallback"
      className={cn(
        'bg-primary-muted text-primary flex size-full items-center justify-center rounded-lg',
        className,
      )}
      {...props}
    />
  )
}

AvatarFallback.propTypes = {
  className: PropTypes.string,
}

export { Avatar, AvatarImage, AvatarFallback }
